import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { ImageImportModule } from '../image_import/image_import.module';
import { ImageOrIframeComponent } from './image-or-iframe.component';
import { TagEditorModule } from '../tag-editor/tag-editor.module';
import { FormsModule } from '@angular/forms';
import { RenderTags } from '../customization/tags.pipe';

@NgModule({
  declarations: [ImageOrIframeComponent],
  exports: [ImageOrIframeComponent],
  imports: [BrowserModule, BrowserAnimationsModule, TranslateModule, TagEditorModule, FormsModule, ImageImportModule],
  providers: [RenderTags]
})
export class ImageOrIframeModule {}



// WEBPACK FOOTER //
// ./src/app/modules/image-or-iframe/image-or-iframe.module.ts